const ClassToggler = {
	Init() {
		const triggers = document.querySelectorAll('.js--toggle-class');

		triggers.forEach(trigger => {
			trigger.addEventListener(
				'click',
				e => {
					const target = document.querySelector(`#${trigger.getAttribute('aria-controls')}`);
					const toggleClass = trigger.getAttribute('data-class-to-toggle') || 'js--is-active';

					trigger.classList.toggle('js--is-active');
					target.classList.toggle(toggleClass);

					/* eslint-disable no-unused-expressions */
					trigger.hasAttribute('toggle-prevent-default') ||
						(trigger.classList.contains('noZensmooth') && e.preventDefault());
				},
				false
			);
		});
	}
};

export default ClassToggler;
